import React from 'react';
import { Megaphone, Users, TrendingUp, BrainCircuit } from 'lucide-react';
import { PILLARS } from '../mock';

const ICONS = { Megaphone, Users, TrendingUp, BrainCircuit };

export default function Pillars() {
  return (
    <section className="py-24 bg-neutral-50 relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-16 fade-in">
          <h2 className="text-4xl md:text-5xl font-black text-black mb-4 leading-tight">
            26+ Tools. 4 Core Business Pillars.<br />
            <span className="relative inline-block">
              One Unified Platform.
              <span className="absolute left-0 right-0 -bottom-1 h-3 bg-[#22c55e] -z-0 rounded opacity-60" />
            </span>
          </h2>
          <p className="text-lg text-neutral-600 max-w-3xl mx-auto">
            Give every department the tools they need while keeping your data, processes organised and teams connected.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <div
                key={p.number}
                className="feature-card fade-in group relative bg-white rounded-2xl p-7 border border-neutral-200"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#22c55e] flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-500 shadow-md">
                  <Icon className="w-7 h-7 text-black" strokeWidth={2.2} />
                </div>
                <div className="text-sm font-black text-neutral-400 tracking-wider mb-2">
                  {p.number} &mdash; {p.title.split(' ')[0].toUpperCase()}
                </div>
                <h3 className="text-xl font-black text-black mb-3 leading-snug">{p.title}</h3>
                <p className="text-[14px] text-neutral-600 leading-relaxed">{p.desc}</p>

                <div className="absolute top-6 right-6 text-5xl font-black text-neutral-100 group-hover:text-[#22c55e]/40 transition-colors">
                  {p.number}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
